import React from 'react';
import './LoadingScreen.css';

const LoadingScreen: React.FC = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <img src="/logo.png" alt="SolBlox" className="loading-logo" />
        <p className="loading-text">
          loading your experience
          <span className="dot-1">.</span>
          <span className="dot-2">.</span>
          <span className="dot-3">.</span>
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
